import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var resolveClientEndpointParameters = function resolveClientEndpointParameters(options) {
  var _options$useFipsEndpo, _options$useDualstack, _options$forcePathSty, _options$useAccelerat, _options$useGlobalEnd, _options$disableMulti;
  return _objectSpread(_objectSpread({}, options), {}, {
    useFipsEndpoint: (_options$useFipsEndpo = options.useFipsEndpoint) !== null && _options$useFipsEndpo !== void 0 ? _options$useFipsEndpo : false,
    useDualstackEndpoint: (_options$useDualstack = options.useDualstackEndpoint) !== null && _options$useDualstack !== void 0 ? _options$useDualstack : false,
    forcePathStyle: (_options$forcePathSty = options.forcePathStyle) !== null && _options$forcePathSty !== void 0 ? _options$forcePathSty : false,
    useAccelerateEndpoint: (_options$useAccelerat = options.useAccelerateEndpoint) !== null && _options$useAccelerat !== void 0 ? _options$useAccelerat : false,
    useGlobalEndpoint: (_options$useGlobalEnd = options.useGlobalEndpoint) !== null && _options$useGlobalEnd !== void 0 ? _options$useGlobalEnd : false,
    disableMultiregionAccessPoints: (_options$disableMulti = options.disableMultiregionAccessPoints) !== null && _options$disableMulti !== void 0 ? _options$disableMulti : false,
    defaultSigningName: "s3"
  });
};
export var commonParams = {
  ForcePathStyle: {
    type: "clientContextParams",
    name: "forcePathStyle"
  },
  UseArnRegion: {
    type: "clientContextParams",
    name: "useArnRegion"
  },
  DisableMultiRegionAccessPoints: {
    type: "clientContextParams",
    name: "disableMultiregionAccessPoints"
  },
  Accelerate: {
    type: "clientContextParams",
    name: "useAccelerateEndpoint"
  },
  DisableS3ExpressSessionAuth: {
    type: "clientContextParams",
    name: "disableS3ExpressSessionAuth"
  },
  UseGlobalEndpoint: {
    type: "builtInParams",
    name: "useGlobalEndpoint"
  },
  UseFIPS: {
    type: "builtInParams",
    name: "useFipsEndpoint"
  },
  Endpoint: {
    type: "builtInParams",
    name: "endpoint"
  },
  Region: {
    type: "builtInParams",
    name: "region"
  },
  UseDualStack: {
    type: "builtInParams",
    name: "useDualstackEndpoint"
  }
};